<template>
  <div class="salon-add">
    <van-form
      ref="form"
      label-width="100px"
    >
      <van-field
        v-model="form.booking_title"
        name="沙龙主题"
        label="沙龙主题:"
        placeholder="请输入沙龙主题"
        required
        :rules="[{ required: true, message: '请输入沙龙主题' }]"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="form.channel_name"
        label="渠道:"
        placeholder="点击选择渠道"
        required
        @click="showChannelPicker = true"
        :rules="[{ required: true, message: '请选择渠道' }]"
        right-icon="arrow"
      />
      <van-popup
        v-model="showChannelPicker"
        position="bottom"
      >
        <div class="booking-home-search">
          <div class="booking-home-search-header">
            <div @click="showChannelPicker = false">
              取消
            </div>
            <div
              class="booking-submit"
              @click="onChannelConfirm"
            >
              完成
            </div>
          </div>
          <div class="booking-division" />

          <form action="/">
            <van-search
              v-model="searchForm.channel"
              placeholder="请输入搜索关键词"
              show-action
              @search="onChannelSearch"
            >
              <template #action>
                <div @click="onChannelSearch(searchForm.channel)">搜索</div>
              </template>
            </van-search>
          </form>
          <div class="booking-division" />

          <div class="booking-home-search-list">
            <div
              v-for="item in channelList"
              :key="item.channel_id"
              class="booking-home-search-item"
              :class="{
                    'booking-home-search-item-current': item.select
                }"
              @click="channelChange(item)"
            >
              {{ item.channel_name }}
            </div>
          </div>
        </div>
      </van-popup>
      <!-- <van-popup
        v-model="showChannelPicker"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="channelList"
          value-key="channel_name"
          @confirm="onChannelConfirm"
          @cancel="showChannelPicker = false"
        />
      </van-popup> -->
      <van-field
        v-show="form.channel_id"
        v-model="form.channel_remark"
        name="渠道备注"
        label="渠道备注:"
        placeholder="请输入渠道备注"
      />
      <van-field
        v-model="form.contact_user"
        name="联系人"
        label="联系人:"
        placeholder="请输入联系人"
        required
        :rules="[{ required: true, message: '请输入联系人' }]"
        @blur="forceUpdate"
      />
      <van-field
        v-model="form.contact_mobile"
        name="联系人电话"
        label="联系人电话:"
        placeholder="请输入联系人电话"
        required
        @blur="forceUpdate"
        :rules="[
            { required: true, message: '请输入联系人电话' },
            { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请输入正确联系人电话' },
        ]"
      />
      <van-field
        name="switch"
        label="是否茶歇:"
        required
      >
        <template #input>
          <van-switch
            :active-value="1"
            :inactive-value="0"
            v-model="form.tea_break_flag"
            size="20"
            @change="onTeaBreakChange"
          />
          <span
            class="salon-chaxie"
            v-show="form.tea_break_flag"
          >
            {{ currentRoomInfo.tea_break }}
          </span>
        </template>
      </van-field>
      <van-field
        v-show="form.tea_break_flag"
        v-model="form.tea_break_remark"
        name="茶歇备注"
        label="茶歇备注:"
        placeholder="请输入茶歇备注"
      />
      <van-field
        name="radio"
        label="讲座专家:"
        required
        :rules="[{ required: true, message: '请选择讲座专家' }]"
      >
        <template #input>
          <van-radio-group
            v-model="form.expert_type"
            direction="horizontal"
            @change="onExpertTypeChange"
          >
            <van-radio name="本院">本院专家</van-radio>
            <van-radio name="外院">外院专家</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-if="form.expert_type === '本院'"
        readonly
        clickable
        name="picker"
        :value="form.expert_name"
        label="本院专家:"
        placeholder="点击选择本院专家"
        :rules="[{ required: form.expert_type === '本院', message: '请选择讲座专家' }]"
        @click="showExpertPicker = true"
        right-icon="arrow"
        required
      />
      <van-popup
        v-model="showExpertPicker"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="expertList"
          value-key="expert_name"
          @confirm="onExpertConfirm"
          @cancel="showExpertPicker = false"
        />
      </van-popup>
      <van-field
        v-if="form.expert_type === '外院'"
        v-model="form.expert_name"
        name="外院专家"
        label="外院专家:"
        placeholder="请输入外院专家"
        @blur="forceUpdate"
      />

      <van-field
        v-model="form.medical_item"
        name="体验项目"
        label="体验项目:"
        placeholder="请输入体验项目"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="form.table_type_name"
        label="摆台样式:"
        placeholder="点击选择摆台样式"
        @click="showSwingTablePicker = true"
        :rules="[{ required: true, message: '请选择摆台样式' }]"
        right-icon="arrow"
        required
      />
      <van-popup
        v-model="showSwingTablePicker"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="swingTableList"
          value-key="value"
          @confirm="onSwingTableConfirm"
          @cancel="showSwingTablePicker = false"
        />
      </van-popup>
      <van-field
        v-model="form.remark"
        name="备注"
        label="备注:"
        placeholder="请输入备注"
        maxlength="200"
      />
      <van-field
        v-model="form.expect_people_num"
        name="预计人数"
        label="预计人数:"
        placeholder="请输入预计人数"
        type="digit"
      />
      <van-field
        v-model="form.expect_receivable"
        name="预计应收费用"
        label="预计应收费用:"
        placeholder="请输入预计应收费用"
        type="number"
        maxlength="200"
      />
      <van-field
        v-model="form.pay_type"
        name="预计结算方式"
        label="预计结算方式:"
        placeholder="请输入预计结算方式"
        maxlength="200"
      />

      <div class="salon-add-btn">
        <el-button
          type="primary"
          @click="submit"
        >完成</el-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import meetingService from "@/apis/meeting/index.js";
import getUserInfo from "@/models/userInfo";
import salonMixins from "./mixins/index.js";
import { Toast } from "vant";

export default {
  mixins: [salonMixins],

  data() {
    return {
      searchForm: {},
      currentUserInfo: {},
      currentRoomInfo: {},
      showPicker: false,

      showChannelPicker: false,
      channelList: [],
      selectChannel: {},

      showExpertPicker: false,
      expertList: [],
      showSwingTablePicker: false,

      swingTableList: [],
      columns: ["杭州", "宁波", "温州", "嘉兴", "湖州"],
      form: {},
    };
  },
  async created() {
    this.roomId = this.$route.query.roomId;

    const { form } = this;
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    form.contact_user = userInfo.user_name;
    form.contact_mobile = userInfo.mobile;
    form.ding_user_id = userInfo.ding_user_id;
    this.currentRoomInfo = await this.getRoomInfoById(this.roomId);
    this.getChannels();
    this.getExpertList();
    this.swingTableList = this.currentRoomInfo.lay_table_obj;
  },
  methods: {
    onTeaBreakChange(value) {
      if (!value) {
        this.form.tea_break_remark = "";
      }
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    async submit() {
      this.$refs.form
        .validate()
        .then(() => {
          const { currentRoomInfo } = this;
          const query = this.$route.query;
          const timeList = decodeURIComponent(query.timeList);
          const params = {
            ...this.form,
            time: timeList.split(","),
            booking_date: query.date,
            room_id: currentRoomInfo.room_id,
          };
          meetingService.bookingAdd(params).then(() => {
            this.$router.replace({
              name: "SalonList",
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSwingTableConfirm(item) {
      const { form } = this;
      form.table_type_id = item.key;
      form.table_type_name = item.value;
      this.showSwingTablePicker = false;
    },
    onExpertConfirm(item) {
      const { form } = this;
      form.expert_id = item.expert_id;
      form.expert_name = item.expert_name;
      this.showExpertPicker = false;
    },
    onExpertTypeChange() {
      const { form } = this;
      form.expert_id = undefined;
      form.expert_name = undefined;
      this.$forceUpdate();
    },
    getExpertList() {
      meetingService.getExpertList({}).then((res) => {
        this.expertList = res;
      });
    },
    onChannelSearch(query) {
      this.getChannels(query);
    },
    channelChange(option) {
      const { channelList } = this;
      channelList.forEach((column) => {
        column.select = false;
      });
      option.select = true;
      this.selectChannel = option;
      this.channelList = [...this.channelList];
    },
    onChannelConfirm() {
      const { form, selectChannel } = this;
      if (!selectChannel.channel_id) {
        Toast("请选择渠道");
        return;
      }
      form.channel_id = selectChannel.channel_id;
      form.channel_name = selectChannel.channel_name;
      this.showChannelPicker = false;
    },
    getChannels(query = "") {
      const params = {
        filter: query,
      };
      meetingService.getChannels(params).then((res) => {
        this.channelList = res;
      });
    },
    onConfirm() {},
  },
};
</script>

<style lang="scss" scoped>
.salon-add {
  .salon-add-btn {
    margin-top: 20px;
    padding: 0 20px;
    .el-button {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.van-overlay {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>